export default function burgerMenu() {
    var burgerMenu = document.querySelector('.burger-menu');
    var overlay = document.querySelector('.header__nav');
    burgerMenu?.addEventListener('click',function(this: any) {
        this.classList.toggle("active");
        overlay?.classList.toggle("is-visible");
    });
}
